<template>
  <div class="contactStaffDetail">
    <van-form label-width="120px" :show-error="false" @submit="onSubmit">
      <van-field
        v-model="form.CustomerNumber"
        :label="$t.contactStaff.customerNumber"
        label-class="number-label"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(form.CustomerNumber)"
            native-type="button"
            :disabled="!form.CustomerNumber ? true : false"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <van-field
        v-model="form.ContactPerson"
        :label="$t.contactStaff.contact"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.Mobile"
        :label="$t.contactStaff.customerPhone"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
      />

      <van-field
        v-model="form.Email"
        :label="$t.contactStaff.email"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.QQ"
        :label="$t.contactStaff.qqNumber"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.WeChat"
        :label="$t.contactStaff.wechat"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.TelePhone"
        :label="$t.contactStaff.telePhoneNumber"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.Liaison"
        :label="$t.contactStaff.liaison"
        :placeholder="$t.meta.input"
      />

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "contactStaffDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isEdit: false,
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
    };
  },
  created() {
    const { IsEdit } = this.$route.query;
    this.isEdit = IsEdit;
    if (IsEdit) {
      var data = JSON.parse(localStorage.getItem("contactStaffDetail"));
      this.form = data;
    } else {
      this.form = {
        ContactId: "",
        CustomerNumber: "",
        ContactPerson: "",
        Mobile: "",
        Email: "",
        QQ: "",
        WeChat: "",
        TelePhone: "",
        Liaison: "",
      };
    }
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      param.UserId = this.UserId;
      var request = null;
      if (this.isEdit) {
        request = this.$api.customerManagement.editCustomerContact(param);
      } else {
        request = this.$api.customerManagement.addCustomerContact(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.contactStaffDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
}
</style>
